import React from 'react'
import RaribleLogo from "../assets/rarible.png"
function NFTsection() {
    return (
        <div className="container-fluid" style={{backgroundColor: "#e2566d"}}>
      <div className="row font-monospace">
        <div className="col-12 col-lg-8 text-center py-lg-5 py-5 ps-lg-5">
          <div className="fs-2" style={{color: "#d3d8da"}}>
            Want to buy one of my original illustrations?
          </div>
          <p className="pt-5 px-5" style={{color: "#33383a"}}>
            I started making some original digital illustrations at the begining of 2021. 
            Some of them turned out quiet good and I decided to put them up for sale. You can buy one of them
            as an NFT and add it to your collectibles. Click 
            <a href="https://rarible.com/random_arts_by_j" target="_blank" className="mylink"> here </a> 
            to check them out and buy one if you like it!
          </p>
        </div>
        <div className="col-12 col-lg-4 text-center align-items-center pe-lg-5">
          <a href="/">
            <img className="img-fluid w-75" src={RaribleLogo} alt="rarible"
          /></a>
        </div>
      </div>
    </div>
    )
}

export default NFTsection;